module.exports = __webpack_public_path__ + "img/category-3.149c7ddb.svg";